import CryptoJS from 'crypto-js';

// 解密数据
export const getAesEncryptValToken = (value: string, keyStr: string, ivStr: string): string => {
    if (!value) return '';
    try {
        const encrypted = CryptoJS.enc.Base64.parse(value);

        const key = CryptoJS.enc.Utf8.parse(keyStr);
        const iv = CryptoJS.enc.Utf8.parse(ivStr);
        // @ts-ignore
        const decrypted = CryptoJS.AES.decrypt({ ciphertext: encrypted }, key, {
            iv: iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });

        return decrypted.toString(CryptoJS.enc.Utf8);
    } catch {
        return '';
    }
};
